/* eslint-disable */

/// <reference path="../../node_modules/@types/resize-observer-browser/index.d.ts" />
declare interface Window {
  recruitee: any;
  analytics: any;
}

declare interface IFrameResizerFrame {
  iFrameResizer: {
    close: () => {};
  };
}

declare module 'iframe-resizer' {
  export function iframeResizer(
    config: any,
    selectorOrFrame: string | HTMLIFrameElement,
  ): IFrameResizerFrame[];
}
